/* global modForm */
import { appendFormInput, saveUserInfoToCookie } from '../../helpers';
/**
 * Handles change on inputs for cookie
 */
export function initUserInformationStorage() {
	const $userInfoObjs = modForm.opts.form.querySelectorAll('[data-save]');

	if ($userInfoObjs.length > 0) {
		$userInfoObjs.forEach(function(elem) {
			appendFormInput(elem.name, modForm.userObj[elem.name]);

			elem.addEventListener('blur', function() {
				saveUserInfoToCookie(this.name, this.value);
			});
		});
	}
}
